<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4OfPRB/tc-custom/9780740786112.jpg?1703224447480" alt="This image is the cover for the book I'd Scream Except I Look So Fabulous"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I'd Scream Except I Look So Fabulous
      </h1>
      <p class="bookDescription body article font2">
        <b>America’s favorite comic strip heroine navigates the perils of being a modern woman in this hilarious collection.</b><br/><br/>By now, we’re all familiar with Cathy’s battles among the four basic guilt groups: food, Mom, love, and career. Women can identify with Cathy Guisewite’s hilarious portrayal of the universal struggles of modern femininity. A confirmed chocoholic, Cathy often consoles herself with one more trip to the fridge, then pays for it with frightening excursions in department store dressing rooms. Mom pushes Cathy to find the man who will give her grandchildren. As for her career, Cathy struggles to be a superstar, even though her desk looks like a disaster area.<br/><br/>In fact, Cathy’s all-too-recognizable life is what endears her to devoted readers. Her countless fans look on their cartoon heroine as a best friend, someone who really knows the trials and tribulations of the working single woman. From Internet dating to Christmas catalog fiascoes, from winter-flu one-upmanship at the office to kitchen technique discussions with Mom, Cathy puts her finger on the kinds of situations that women face in their real lives on a daily basis. In this <i>Cathy</i> collection, <i>I’d Scream Except I Look So Fabulous</i>, our favorite cartoon character once again shows why her popularity soars. Who can’t relate to the discomfort fashion sometimes dictates in order to be trendy.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cathy Guisewite
      </h2>
      
      <p class="authorDescription body article">Cathy Guisewite launched Cathy in newspapers in 1976, becoming one of the few female cartoonists to hit the daily strip Big Time. Cathy Guisewite's many awards include a 1993 Reuben Award for Outstanding Cartoonist of the Year and an Emmy for Outstanding Animated Program for her CBS Cathy special.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3854dae0